module.exports = __webpack_public_path__ + "9ea8e05765f20d6aa3523fc74a4605d4.png";